/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    container: "container",
    hexInput: "hex-input",
    opacityInput: "opacity-input",
};
//# sourceMappingURL=resources.js.map
